import React from 'react';
export function HeroSection() {
  return <section className="relative w-full flex flex-col text-center px-4 py-8 sm:py-16 items-center justify-center pl-[20px] pr-[20px] pt-[20px] pb-[20px]" style={{
    background: 'linear-gradient(135deg, #0a0a0a 0%, #1a0d00 30%, #1a0800 60%, #0a0a0a 100%)'
  }} data-id="element-253">
      {/* Logo */}
      <div className="mb-4" data-id="element-254">
        <span className="text-[#F97316] text-xl sm:text-2xl font-black tracking-widest" data-id="element-255">
          🏀 EDULABS
        </span>
      </div>

      {/* Main headline */}
      <h1 className="font-black text-white max-w-5xl sm:text-5xl md:text-7xl lg:text-8xl mb-[0px] text-[28px]" data-id="element-256">
        Todo tu año de básquet
        <br data-id="element-257" />
        <span className="text-[#F97316]" data-id="element-258">resuelto.</span>
      </h1>

      {/* Mockup image */}
      <div className="w-full max-w-[290px] sm:max-w-[360px] md:max-w-md mx-auto mb-4" style={{
      aspectRatio: '1/1'
    }} data-id="element-259">
        <img src="https://cdn.magicpatterns.com/uploads/bTTAgWEphgr6anJn2gS61W/Coordinacion_(1).png" alt="EDULABS MegaPack Básquet Listo — Combo Completo" className="w-full h-full object-contain" width={400} height={400} fetchPriority="high" data-id="element-260" />
      </div>

      {/* Subtitle */}
      <p className="text-[#F97316] sm:text-2xl font-bold max-w-3xl mb-[0px] text-[15px] mt-[0px]" data-id="element-261">
        6 Tomos · 101 drills · 6 Bonos · Listo para usar.
      </p>

      {/* Body */}
      <p className="text-white sm:text-lg max-w-2xl mb-[2px] pt-[8px] pb-[8px] text-[16px]" data-id="element-262">
        Tu año completo de básquet listo: sesiones, técnica, táctica, drills,
        gestión y comunicación. Sin improvisar.
      </p>

      {/* Pills */}
      <div className="flex flex-nowrap mb-[10px] gap-[5px] items-center justify-center mx-auto" data-id="element-263">
        <span className="bg-black/50 border border-[#F97316]/40 text-white text-[10px] sm:text-sm font-semibold px-2 sm:px-3 py-1 sm:py-1.5 rounded-full whitespace-nowrap" data-id="element-264">
          📄 PDF digital
        </span>
        <span className="bg-black/50 border border-[#F97316]/40 text-white text-[10px] sm:text-sm font-semibold px-2 sm:px-3 py-1 sm:py-1.5 rounded-full whitespace-nowrap" data-id="element-265">
          ⚡ Acceso inmediato
        </span>
        <span className="bg-black/50 border border-[#F97316]/40 text-white text-[10px] sm:text-sm font-semibold px-2 sm:px-3 py-1 sm:py-1.5 rounded-full whitespace-nowrap" data-id="element-266">
          🏀 Todos los niveles
        </span>
      </div>

      {/* CTA Button */}
      <a href="#pricing" className="btn-orange-pulse bg-[#F97316] font-black text-base sm:text-2xl px-6 sm:px-10 py-4 sm:py-5 rounded-xl hover:bg-[#FB923C] transition-colors inline-block mb-5 w-full sm:w-auto max-w-sm text-[#FFFFFF] mt-4" data-id="element-267">
        💥 → QUIERO MI MEGAPACK AHORA
      </a>

      {/* Trust badges */}
      <p className="text-gray-300 text-xs sm:text-sm flex flex-wrap items-center justify-center gap-2 sm:gap-3" data-id="element-268">
        <span data-id="element-269">🛡️ Garantía 7 días sin preguntas</span>
        <span data-id="element-270">🔒 Pago 100% seguro</span>
        <span data-id="element-271">💳 Tarjetas | PayPal</span>
      </p>
    </section>;
}